
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/country_not_supported",
      function () {
        return require("private-next-pages/country_not_supported.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/country_not_supported"])
      });
    }
  